import { render, staticRenderFns } from "./AddMonitoringZone.vue?vue&type=template&id=206d9bce&"
import script from "./AddMonitoringZone.vue?vue&type=script&lang=js&"
export * from "./AddMonitoringZone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports